import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, permission, allowCompanySetup = false }) {
  const { isAuthenticated, user, hasPermission } = useAuth();
  const location = useLocation();
  if (!isAuthenticated) return <Navigate to={`/login?redirectUrl=${encodeURIComponent(location.pathname)}`} replace />;
  if (!allowCompanySetup && !user?.companyId) return <Navigate to="/company-setup" replace />;
  if (permission && !hasPermission(permission)) return <Navigate to="/unauthorized" replace />;
  return children;
}
